import React, { useEffect, useRef, useContext } from 'react';
import { AppContext } from '../context/AppContext.jsx';
import { Oval } from 'react-loader-spinner';
import gsap from 'gsap'; 
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';
gsap.registerPlugin(ScrollToPlugin);


const SiteLoader = ({removeLoader = false }) => {
	const loaderRef = useRef(null);
	const { loaderDuration } = useContext(AppContext);
	const disapperDuration = 2;

	useEffect(() => {
		if (!removeLoader) {
			gsap.to(loaderRef.current, {
				opacity: 0,
				duration: disapperDuration,
				delay: loaderDuration - disapperDuration,
				ease: "power2.out",
				onComplete: () => { 
					if (loaderRef.current) {
						loaderRef.current.style.display = 'none';
						loaderRef.current.style.pointerEvents = 'none'; 
						loaderRef.current.classList.add('hidden');
					} 
				}
			});

			gsap.to(window, {
				duration: 0,
				scrollTo: { y: 0 },
				ease: "power2.out"
			});
		}
	}, [removeLoader]);

	return (
		<div className="site-loader" ref={loaderRef}>
			<div className="container">
			<Oval
				height={50}
				width={50}
				color="#fff"
				wrapperStyle={{}}
				wrapperClass=""
				visible={true}
				ariaLabel='oval-loading'
				secondaryColor="#ffffff30"
				strokeWidth={2}
				strokeWidthSecondary={2}
			/>
			</div>
		</div>
	);
};

export default SiteLoader;
